import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";
import anime from 'animejs/lib/anime.es.js';

import Header, { NavList } from "@/components/Base/header";
import Contact from "@/components/Base/contact";
import Footer from "@/components/Base/footer";
import { Subscribe } from "@/components/Base/css";
import SvgsCommons from "@/components/svgs/commons";
import SvgsOthers from "@/components/svgs/others";
import { useActionWhenScrollToView } from '@/utils/index'
import { newPath, EmailHost, EmailLink } from '@/utils/index'

import M1 from '@/static/images/products/m1.png'
import P1 from '@/static/images/products/p1.png'
import P2 from '@/static/images/products/p2.png'
import P3 from '@/static/images/products/p3.png'
import P4 from '@/static/images/products/p4.png'
import P5 from '@/static/images/products/p5.png'
import P6 from '@/static/images/products/p6.png'
import S1 from '@/static/images/products/s1.png'
import S2 from '@/static/images/products/s2.png'
import S3 from '@/static/images/products/s3.png'
import S4 from '@/static/images/products/s4.png'
import DmailLogo from '@/static/images/products/dmail.png'
import Notify from '@/static/images/products/notify.gif'
import Monitor from '@/static/images/products/monitor.gif'
import Banner from '@/static/images/products/banner.gif'
import { Root, Progress } from './css'

const Index = ({ store }) => {
  const { isMobile } = store.common;
  const history = useHistory();

  const [current, setCurrent] = useState(0)
  const [clickIndex, setClickIndex] = useState(1)
  const _setCurrent = (n) => {
    setCurrent(n)
    const index = clickIndex+1
    setClickIndex(index)
    const dom = document.querySelector(`#a${n}`)
    dom && (dom.style.zIndex = index)
  }
  
  const functionsRef = useRef(null)
  useActionWhenScrollToView(functionsRef, () => {
    const target = document.querySelector('#__functions')
    target && target.classList.add('show')
  }, true, () => {
    // const target = document.querySelector('#__functions')
    // target && target.classList.remove('show')
  })

  const progressFn = (action = 'add') => (target) => {
    const parent = target.parentElement
    parent && parent.classList[action]('show')
    parent && action === 'add' && parent.classList.add('show-once')
  }
  const progress1Ref = useRef(null)
  const progress2Ref = useRef(null)
  useActionWhenScrollToView(progress1Ref, progressFn(), false, progressFn('remove'))
  useActionWhenScrollToView(progress2Ref, progressFn(), false, progressFn('remove'))

  const subRef = useRef(null)
  useActionWhenScrollToView(subRef, () => {
    const target = document.querySelector('#__sub_imgs')
    target && target.classList.add('show')
  }, false, () => {
    const target = document.querySelector('#__sub_imgs')
    target && target.classList.remove('show')
  })

  const accountsRef = useRef(null)
  // useActionWhenScrollToView(accountsRef, (target) => {
  //   const parent = target.parentElement
  //   anime({
  //     targets: parent.querySelectorAll('li'),
  //     translateX: 400,
  //     opacity: [0, 1],
  //     duration: 1500,
  //     delay: anime.stagger(200) // increase delay by 200ms for each elements.
  //   });
  //   setTimeout(() => {
  //     parent.classList.add('end')
  //   }, 2000);

  //   setTimeout(() => {
  //     anime({
  //       targets: document.querySelector('#__aimgs'),
  //       // translateX: [200, 0],
  //       translateY: [400, 0],
  //       opacity: [0, 1],
  //       duration: 3200,
  //     });
  //   }, 300)
  // }, true)

  useEffect(() => {
    _setCurrent(0)
  }, [])

  return (
    <Root className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[0].name} />
      <div className="content">
        <div className="center dapp dapp1">
          <div className="info">
            <h1>Dmail DApp</h1>
            <div className="desc">
              <p>Dmail DApp is a user self-hosted decentralized mailbox solution deployed on multiple chains. It expands the boundaries of information and asset interaction for users in the Web2/3 world, exploring more possibilities for the decentralized realm.</p>
            </div>
            <div className="actions">
              <a className="filled-red" href={EmailLink} target="_blank">Launch Dmail<SvgsCommons type="arrow" /></a>
            </div>
          </div>
          <div className="img"><img src={isMobile ? M1 : Banner} width={isMobile ? "" : 587} /></div>
        </div>
        <div className="functions" id="__functions">
          <ul className="center">
            <li>
              <div className="img"><img src={P1} alt="" /></div>
              <div>
                <div className="name" ref={functionsRef}>End-to-end Encrypted</div>
                <div className="desc"><p>Utilizing advanced cryptography for anonymous and secure P2P communication.</p></div>
              </div>
            </li>
            <li>
              <div className="img"><img src={P3} alt="" /></div>
              <div>
                <div className="name">Data Ownership</div>
                <div className="desc"><p>Dedicated storage space ensures ownership of your data and the benefits it brings.</p></div>
              </div>
            </li>
            <li>
              <div className="img"><img src={P2} alt="" /></div>
              <div>
                <div className="name">AI Powered</div>
                <div className="desc"><p>Provide amazing intelligent editing and auto-replying support powered by GPT-4.</p></div>
              </div>
            </li>
          </ul>
        </div>
        <div className="accounts center">
          <h2>One-stop solution for messaging.</h2>
          <div className="desc">Dmail DApp consolidates emails, assets, notifications, subscriptions, and all messaging facets, securing and simplifying them through WEB3!</div>
          <div className="flex">
            <ul>
              <li className={`${current === 0 ? 'on' : ''}`} onClick={() => _setCurrent(0)}>
                <h3>Multiple Identities</h3>
                <p>Supports toggling between personalized domains, DIDs, wallet addresses, and other multi-identity communications.</p>
                {isMobile ? <SvgsCommons type="down" width={12} height={6} /> : null}
              </li>
              {isMobile ? <div className={`li-img ${current === 0 ? 'on' : ''}`}><img src={P4} alt="" /></div> : null}
              <li className={`${current === 1 ? 'on' : ''}`} onClick={() => _setCurrent(1)} ref={accountsRef}>
                <h3>NFT Domain Accounts</h3>
                <p>Unique domain accounts featuring on-chain points attributes, scarcity, and support for trading or transfers.</p>
                {isMobile ? <SvgsCommons type="down" width={12} height={6} /> : null}
              </li>
              {isMobile ? <div className={`li-img ${current === 1 ? 'on' : ''}`}><img src={P5} alt="" /></div> : null}
              <li className={`${current === 2 ? 'on' : ''}`} onClick={() => _setCurrent(2)}>
                <h3>Points System</h3>
                <p>Leveraging the Mail to Earn model, users are credentialed and rewarded for their contributions.</p>
                {isMobile ? <SvgsCommons type="down" width={12} height={6} /> : null}
              </li>
              {isMobile ? <div className={`li-img ${current === 2 ? 'on' : ''}`}><img src={P6} alt="" /></div> : null}
            </ul>
            {isMobile ? null : (
              <div className="imgs" id="__aimgs">
                <img src={P4} alt="" id="a0" className={`${current === 0 ? 'on' : ''}`} />
                <img src={P5} alt="" id="a1" className={`${current === 1 ? 'on' : ''}`} />
                <img src={P6} alt="" id="a2" className={`${current === 2 ? 'on' : ''}`} />
              </div>
            )}
          </div>
        </div>
        <Progress className={`${isMobile ? 'sub-mobile' : ''}`}>
          <div className="center">
            <div className="flex">
              <div className="img"><img src={Notify} alt="" width={isMobile ? '' : 355} /></div>
              <div className="line"></div>
              <div className="info" ref={progress1Ref}>
                <h3>Multi-channel Notifications</h3>
                <p><i></i>Browser Pop-up Notifications</p>
                <p><i></i>Social App Notifications</p>
                <p><i></i>Email Auto-forwarding</p>
              </div>
            </div>
            <div className="flex flex-reverse">
              <div className="info" ref={progress2Ref} style={{ left: '-80px' }}>
                <h3>Multi-dimensional Monitoring</h3>
                <p><i></i>On-chain Monitoring</p>
                <p><i></i>Off-chain Monitoring</p>
              </div>
              <div className="line"></div>
              <div className="img"><img src={Monitor} alt="" width={409} /></div>
            </div>
          </div>
        </Progress>
        <div className="subscription center">
          <h2>Subscription Center</h2>
          <div className="desc" style={{ width: isMobile ? '' : '650px' }}>Unlock instant updates and important notifications, engage with your favorite Web3 projects and earn rewards just for staying informed!</div>
          {isMobile ? (
            <img src={S4} alt="" width={"100%"} />
          ) : (
            <div className="img"  ref={subRef} id="__sub_imgs">
              <img src={S1} alt="" height={230} />
              <img src={S2} alt="" height={168} />
              <img src={S3} alt="" height={140} />
            </div>
          )}
        </div>
      </div>
      <div className="bottom">
        <div className="center">
          <Subscribe className={`sub ${isMobile ? 'mobile' : ''}`}>
            {isMobile ? null : (
              <div className="pic">
                <img src={DmailLogo} height={161} />
              </div>
            )}
            <div className="detail">
              <h2>Dmail DApp</h2>
              <p>Intelligent and Secure Messaging keeping you informed and connected.</p>
              <div style={{ display: 'inline-block' }}>
                <a className="filled-red to-sub" href={`${EmailLink}`} target="_blank">Start now</a>
              </div>
            </div>
          </Subscribe>
          <Contact />
          <Footer />
        </div>
      </div>
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))